<template>
  <v-container fluid grid-list-xl>
    <v-layout row wrap>
      <v-flex pb-0 xs12>
        <v-chip color="#e0e0e0" text-color="black">
          <v-avatar color="#0096e8">
            <v-icon small color="#f9f9f9">fas fa-filter</v-icon>
          </v-avatar>
          <strong>Filtrando registros </strong>&nbsp;{{ filteredPeriod }}
        </v-chip>
        <!-- <v-btn
              round
              color="#0096e8"
              dark
              @click="getConversions"
              style="width: 100%; height: 50px; @media (max-width: 400px)"
              :class="{ 'margin-top-mobile': $vuetify.breakpoint.xsOnly }"
            >
              Exportar como CSV
            </v-btn> -->
      </v-flex>
      <v-flex>
        <v-layout row wrap>
          <v-flex xs12 sm6 md3 style="padding-left: 0;">
            <a-date-field
              xs12
              label="Período entre"
              v-model="dateFrom"
              dateFormat="DD/MM/YYYY"
              clearable
            ></a-date-field>
          </v-flex>
          <v-flex xs12 sm6 md3 style="padding-left: 0;">
            <a-date-field
              xs12
              label="Até"
              v-model="dateTo"
              dateFormat="DD/MM/YYYY"
              :class="{ 'margin-top-mobile': $vuetify.breakpoint.xsOnly }"
              clearable
            ></a-date-field>
          </v-flex>
          <v-flex xs12 sm6 md4 style="padding-left: 0; margin-top: 4px;">
          <v-select
                box
                label="Oferta"
                :loading="isLoading"
                v-model="select"
                :items="offers"
                item-text="title"
                item-value="id"
                return-object
              ></v-select>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm6 md2 style="padding-left: 0;">
            <v-btn
              round
              color="#0096e8"
              dark
              @click="getConversions"
              style="width: 100%; height: 50px; @media (max-width: 400px)"
              :class="{ 'margin-top-mobile': $vuetify.breakpoint.xsOnly }"
            >
              Filtrar
            </v-btn>
          </v-flex>
          <v-flex xs12 sm6 md2 style="padding-left: 0;">
            
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex pb-0 xs12>
        <v-data-table
          :headers="headers"
          :items="conversions"
          :loading="isLoading"
          :search="search"
          no-data-text="Sem registros de conversões para o período selecionado"
          rows-per-page-text="Registros por página"
          :rows-per-page-items="customLocale"
        >
          <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
          <template v-slot:items="props">
            <td>{{ props.item.clickId }}</td>
            <td class="text-xs-left">{{ formattedDate(props.item.goalAt) }}</td>
            <td class="text-xs-left">{{ props.item.offerName }}</td>
            <td class="" :class="{'uppercase': props.item.goal === ''}">
              <v-chip
                color="#66BB6A"
                class="ml-0 mr-2 black--text"
                small
              >
                {{ transformString(props.item.goal)  }}
              </v-chip>
            </td>
            <td class="text-xs-center">R$ {{ props.item.transactionAmount != null ? formatCurrency(props.item.transactionAmount) : '-' }}</td>
            <td class="text-xs-center"><b>R$ {{ formatCurrency(props.item.payout) }}</b></td>
          </template>
          <template v-slot:pageText="props">
            Linhas {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}  
            
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn color="#6d6d6d" flat icon v-on="on" @click="exportToExcel" style="margin-right: -15px;">
                  <v-icon>download</v-icon>
                </v-btn>
              </template>
              <span>Exportar para CSV</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios';
import ExcelJS from 'exceljs';
export default {
  data() {
    return {
      dateFrom: new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().substr(0, 10),
      dateTo: new Date().toISOString().substr(0, 10),
      search: '',
      customLocale: [5, 10, 25, { text: 'Todos', value: -1 }],
      isLoading: false,
      showModal: false,
      nome: '',
      whatsapp: '',
      offers: [{ id: 0, title: 'Todas as ofertas' }],
      select: { id: 0, title: 'Todas as ofertas' },
      links: ['Semana', 'Mês', '3 meses', 'Tudo'],
      headers: [
        {
          text: 'Id da transação',
          align: 'left',
          sortable: false,
          value: 'name',
          class: 'td'
        },
        {
          text: 'Data do evento',
          align: 'left',
          sortable: false,
          value: 'date'
        },
        {
          text: 'Oferta',
          align: 'left',
          sortable: false,
          value: 'offer'
        },
        {
          text: 'Evento de conversão',
          align: 'left',
          sortable: false,
          value: 'nameIndication'
        },
        {
          text: 'Valor da transação',
          align: 'left',
          sortable: false,
          value: 'transactionAmount'
        },
        {
          text: 'Comissão',
          align: 'left',
          sortable: false,
          value: 'isConverted'
        }
      ],
      conversions: []
    };
  },

  computed: {
    filteredPeriod() {
      return `período entre ${this.$moment(this.dateFrom).format('DD/MM/YYYY')} a ${this.$moment(
        this.dateTo
      ).format('DD/MM/YYYY')}`;
    }
  },

  mounted() {
    this.getOffers();
    this.getConversions();
  },

  methods: {
    exportToExcel() {
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Dados');

      // Adicionar headers
      const headerRow = this.headers.map(header => header.text);
      worksheet.addRow(headerRow);

      // Adicionar dados
      this.conversions.forEach(item => {
        const dataRow = [
          item.clickId,
          this.formattedDate(item.goalAt),
          item.offerName,
          this.transformString(item.goal),
          item.transactionAmount != null ? this.formatCurrency(item.transactionAmount) : '-',
          `R$ ${this.formatCurrency(item.payout)}`
        ];
        worksheet.addRow(dataRow);
      });

      // Preparar para o download
      workbook.xlsx.writeBuffer().then(buffer => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'data.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      });
    },
    getOffers() {
      axios
        .post('https://api.consigmais.com.br/ds/indication/offers')
        .then((response) => {
          response.data.forEach((obj) => {
            this.offers.push(obj);
          });
        })
        .catch((error) => {
          console.error(error);
          this.isLoading = false;
        });
    },
    getOfferTitle(id) {
      const offer = this.offers.find((obj) => obj.id === id);
      return offer ? offer.title : id;
    },
    formattedDate(date) {
      return this.$moment(date).format('DD/MM/YYYY HH:mm');
    },
    formatCurrency(value) {
      return Number(value).toFixed(2);
    },
    transformString(inputString) {

      var modifiedString = inputString.replace(/[-_]/g, ' ');

      modifiedString = modifiedString.replace(/(^|\s)\S/g, (match) => match.toUpperCase());

      return modifiedString;
    },
    getConversions() {
      this.isLoading = true;
      axios
        .post('https://api.consigmais.com.br/ds/affiseConversions/findByAffiliate', {
          dateTo: this.dateTo,
          dateFrom: this.dateFrom,
          offerId: this.select.id != 0 ? this.select.id : null
        })
        .then((response) => {
          if(response.data != null){
            this.conversions = response.data.reverse().filter((item) => item.payout > 0);
          }
            this.isLoading = false;

        })
        .catch((error) => {
          console.error(error);
          this.$notifyUser({
            type: 'error',
            message: 'Ocorreu um erro'
          });
        });
    }
  }
};
</script>

<style>
.v-datatable thead tr:first-child {
  background-color: #e0e0e0;
  border-bottom-left-radius: 30px;
  border-bottom-right-radius: 40px;
}

.v-datatable td {
  height: 80px !important;
  font-size: 15px !important;
}

.column {
  font-size: initial !important;
  color: #000 !important;
}

.btn-header {
  background-color: #f3f3f3;
  height: 30px;
  text-transform: capitalize;
}

.margin-top-mobile {
  margin-top: -40px;
}

</style>


// WEBPACK FOOTER //
// src/pages/Production.vue